// type-only: matrix-js-sdk's main entry is ESM-only; a value import of EventType breaks Jest (see commit 6980edd20)
import type { EventType } from 'matrix-js-sdk';
import { MatrixClient } from 'matrix-js-sdk';

// Matrix doesn't automatically track which rooms are "direct" for either party - the server only
// stamps is_direct: true onto the invite event's content, for the invited user to notice. Each
// side's own m.direct account data (the actual source getDirectRoomIdSet reads from - see
// roomSummaries.ts) has to be updated explicitly by the client, on both the creating and the
// invited side. Safe to call repeatedly - a no-op once the room is already recorded.
export const markRoomAsDirect = async (client: MatrixClient, otherUserId: string, roomId: string): Promise<void> => {
    const content = (client.getAccountData('m.direct' as EventType.Direct)?.getContent() as Record<string, string[]>) ?? {};
    const existingRoomIds = content[otherUserId] ?? [];
    if (existingRoomIds.includes(roomId)) return;
    await client.setAccountData('m.direct' as EventType.Direct, { ...content, [otherUserId]: [...existingRoomIds, roomId] });
};
